module.exports = __webpack_public_path__ + "public/SiteIcons/darkIcon.svg?e43f6f3c";